export default __webpack_public_path__ + "static/media/right-arrow-blue.1e888222.svg";